import API from '../api'
import {ActionTypes} from '../api/constants'
import {Module} from '../api/org'
import {IAction} from '../models'

export interface IOrg {
  modules: Module[]
}

export const UpdateOrgTypes = (ids: number[]) => {
  const f = (l: Module[]): IAction<IOrg> => ({
    type: ActionTypes.UpdateOrgTypes,
    payload: {...initIOrg(), modules: l},
  })

  return dispatch => {
    API.listModule(ids).then(res => {
      let ots = res.data.items
      console.log('get module', ots)
      if (ots === null) {
        dispatch(f([]))
      } else {
        dispatch(f(ots))
      }
    })
  }
}

const initIOrg = (): IOrg => ({
  modules: [],
})

const reducer = (state = initIOrg(), action: IAction<IOrg>): IOrg => {
  switch (action.type) {
    case ActionTypes.UpdateOrgTypes:
      if (action.payload === undefined) {
        return state
      }

      return {
        ...state,
        modules: action.payload.modules,
      }

    default:
      return state
  }
}

export default reducer
